import React from 'react'
import PropTypes from 'prop-types'
import {
  COLORS,
  HEADING_TYPE,
  TEXT_SIZES,
  IMAGE_SIZES,
  CONTENT_TYPES,
  USER_ROLES,
} from '@helpers/constants'
import Heading from '@components/Heading'
import Text from '@components/Text'
import { ImageSize } from '@components/Image/style'
import { getBookImageUrl } from '@helpers/book'
import Image from '@components/Image'
import {
  getSubjectBackgroundClass,
  getSubjectTextClass,
} from '@helpers/subject'
import SubjectHeader from '@components/SubjectHeader'
import Icon from '@components/Icon'
import { Link } from 'react-router-dom'
import BlockRenderer from '@views/BlockRenderer'
import { useCurrentUser } from '@hooks/useCurrentUser'

const SearchResultBookItem = (props) => {
  const { book, isStudent } = props
  const {
    id,
    subject,
    name,
    description,
    level: { name: level },
    schoolYear,
    published,
    isHidden,
    public: isPublic,
  } = book
  const imageUrl = getBookImageUrl(book)
  const { currentUser } = useCurrentUser()

  return (
    <Link to={'/bok/' + id}>
      <div className={'flex w-full bg-darkLightGrey relative rounded-[4px] p-4 mb-4'} >
        {imageUrl ? (
          <Image
            size={IMAGE_SIZES.SMALL}
            imageUrl={imageUrl}
          />
        ) : (
          <div className={'bg-darkGrey ' + ImageSize.small} />
        )}
        <div className={'ml-4'}>
          <div className={'flex items-center mb-2'}>
            <div
              className={`rounded-full py-1 px-3 ${getSubjectBackgroundClass(
                subject?.slug,
                'dark'
              )}`}
            >
              <SubjectHeader
                subject={subject}
                color={COLORS.WHITE.TEXT}
                type={CONTENT_TYPES.BOOK}
                textSize={TEXT_SIZES.XXXSMALL}
                dark
              />
            </div>

            <div
              className={`flex pl-2 ${getSubjectTextClass(subject?.slug, 'dark')}`}
            >
              { !isStudent &&
                <>
                  <Icon icon={'Classes'} />
                  <Text
                    size={TEXT_SIZES.XXXSMALL}
                    color={getSubjectTextClass(subject?.slug, 'dark')}
                    extraClasses={'pl-2 whitespace-nowrap'}
                  >
                    {schoolYear.name}
                  </Text>
                  <Text
                    size={TEXT_SIZES.XXXSMALL}
                    color={getSubjectTextClass(subject?.slug, 'dark')}
                    extraClasses={'pl-2 whitespace-nowrap'}
                  >
                    Nivå: {level}
                  </Text>
                </>
              }

              {currentUser?.userRole === USER_ROLES.ADMIN && (
                <div className={'absolute right-4'}>
                  {!published && (
                    <Text
                      size={TEXT_SIZES.XXXSMALL}
                      color={COLORS.ALERT_RED.TEXT}
                    >
                      UTKAST
                    </Text>
                  )}
                  {isHidden && (
                    <Text size={TEXT_SIZES.XXXSMALL} color={COLORS.ALERT_RED.TEXT}>
                      GÖMD
                    </Text>
                  )}
                  {isPublic && (
                    <Text
                      size={TEXT_SIZES.XXXSMALL}
                      color={COLORS.ALERT_GREEN.TEXT}
                    >
                      PUBLIKT
                    </Text>
                  )}
                </div>
              )}
            </div>
          </div>

          <Heading
            size={TEXT_SIZES.MEDIUM}
            headingLevel={HEADING_TYPE.H3}
            color={COLORS.BLACK.TEXT}
          >
            {name}
          </Heading>

          <div className={'line-clamp-3'}>
            { !isStudent &&
              <BlockRenderer
                content={description}
              />
            }
          </div>
        </div>
      </div>
    </Link>
  )
}

SearchResultBookItem.propTypes = {
  book: PropTypes.object,
}

export default SearchResultBookItem
